function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var defaultOptions = {
  fallback: 'https://www.xiaopeng.com/m/download.html',
  universalLink: 'https://app.xiaopeng.com/${url}',
  param: '_rt',
  prompt: function prompt() {}
};
/**
 * 初始化 to-app 的全局配置
 *
 * @export
 * @param {Options} options
 */

export function setup(options) {
  defaultOptions = _objectSpread({}, defaultOptions, options);
}
/**
 * 判断是否在小鹏 app 内部
 *
 * @export
 * @returns {boolean}
 */

export function isHybrid() {
  return navigator.userAgent.indexOf('xiaopeng') !== -1;
}
/**
 * 部分 app 内置的浏览器受限，判断后走 reject 流程
 *
 * @returns {boolean}
 */

function isRejected() {
  var ua = navigator.userAgent.toLowerCase();
  return Boolean(ua.match(/MicroMessenger/gi)) ||
  // 微信内置浏览器
  Boolean(ua.match(/dingtalk/gi)) ||
  // 钉钉内置浏览器
  Boolean(ua.match(/weibo/gi)) ||
  // 微博内置浏览器
  ua.match(/\sqq/gi) && ua.indexOf('mqqbrowser') < 0 // QQ 内置浏览器
  ;
}

function isIOS() {
  var ua = navigator.userAgent.toLowerCase();
  return Boolean(ua.match(/iphone|ipod/gi)) || Boolean(ua.match(/ipad/gi));
}
/**
 * 通过配置转换出要使用的统一 url
 *
 * @param {*} url
 * @param {*} options
 * @returns {string}
 */

function getUniersalLink(url, options) {
  var fallback = options.fallback,
    universalLink = options.universalLink,
    param = options.param;
  var map = {
    url: url
  };
  var re = universalLink.replace(/\${([^}]*)}/g, function (m, n) {
    return map[n];
  });
  return /\?(?:.+)=(?:.*)/.test(re) ? "".concat(re, "&").concat(param, "=").concat(encodeURIComponent(fallback)) : "".concat(re, "?").concat(param, "=").concat(encodeURIComponent(fallback));
}
/**
 * Android 下打开 app 的检测
 *
 * @param {(success: boolean) => void} callback
 */

function appOpenCheck(callback) {
  var clickTime = Date.now();
  function check(elsTime) {
    if (elsTime > 3000 || document.hidden || document.webkitHidden) {
      callback(true);
    } else {
      callback(false);
    }
  } // 启动间隔 20ms 运行的定时器，并检测累计消耗时间是否超过 3000ms，超过则结束

  var count = 0;
  var intHandle = setInterval(function () {
    count++;
    var elsTime = Date.now() - clickTime;
    if (count >= 100 || elsTime > 3000) {
      clearInterval(intHandle);
      check(elsTime);
    }
  }, 20);
}
/**
 * 对外 api，传入配置唤起 app
 *
 * @export
 * @param {string} url
 * @param {Options} [options={}]
 * @returns {void}
 */

export default function toApp(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var usedOptions = _objectSpread({}, defaultOptions, options);
  var prompt = usedOptions.prompt,
    fallback = usedOptions.fallback; // 已经在 app 中了

  if (isHybrid()) {
    return;
  }
  if (isRejected()) {
    prompt();
  } else if (isIOS()) {
    // iOS 的 universal links
    window.location.href = getUniersalLink(url, usedOptions);
  } else {
    // Android 用 iframe src 检测是否安装 app
    var src = "xiaopeng://".concat(url);
    var ifr = document.createElement('iframe');
    ifr.src = src;
    ifr.style.display = 'none';
    appOpenCheck(function (success) {
      if (!success) {
        window.location.href = fallback;
      }
    });
    document.body.appendChild(ifr);
    setTimeout(function () {
      document.body.removeChild(ifr);
    }, 2000);
  }
}